import { Button, Drawer, Group, Title, useMantineTheme } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import ErrorAlert from 'components/shared/ErrorAlert';
import { withAsyncContent } from 'hocs/withAsyncContent';
import { useCreateMeetingDrawerModal } from 'stores/global/CreateMeetingDrawerModal';
import { leadDrawer } from 'stores/global/RootStore';
import { useDevices } from 'utils/devices';

import Details from './Details';

import s from './LeadDrawer.module.scss';

const AsyncDetails = withAsyncContent(Details, {
  ComponentEmpty: ErrorAlert,
});

export const LeadDrawer: React.FC = () => {
  const createMeetingDrawerModal = useCreateMeetingDrawerModal();
  const theme = useMantineTheme();
  const { isPhone } = useDevices();

  const { lead, close, isOpen, loadingStage, entity, showButton } = leadDrawer;

  const handleOpenDrawer = React.useCallback(() => {
    if (lead.value) {
      createMeetingDrawerModal.openWithLead(lead.value.id);
      close();
    }
  }, [lead, close, createMeetingDrawerModal]);

  return (
    <Drawer.Root
      opened={isOpen}
      onClose={close}
      position="right"
      size={isPhone ? '100%' : 'md'}
      offset={isPhone ? 0 : theme.spacing.lg}
      radius={isPhone ? 0 : 'md'}
      padding={0}
    >
      <Drawer.Overlay />
      <Drawer.Content>
        <Drawer.Body className={s.root} h="100%">
          <Group wrap="nowrap" align="flex-start" justify="space-between" className={s.root__header}>
            <Title size={isPhone ? 'h3' : 'h2'} fw={600}>
              Детали заявки
            </Title>
            <Drawer.CloseButton onClick={close} size={32} icon={<IconX size={24} />} />
          </Group>
          {isOpen && (
            <div className={s.root__content}>
              <AsyncDetails loadingStage={loadingStage} isEmpty={!entity} />
            </div>
          )}
          {isOpen && showButton.value && (
            <div className={s.root__footer}>
              <Button
                fullWidth
                size={isPhone ? 'md' : 'lg'}
                disabled={!loadingStage.isSuccess}
                onClick={handleOpenDrawer}
              >
                Назначить встречу
              </Button>
            </div>
          )}
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};

export default observer(LeadDrawer);
